module.exports = __webpack_public_path__ + "media/images/badge/supporter_secondary-871a6941473b54a0cff039c5bb955b80.png";